module.exports = __webpack_public_path__ + "img/manifestation-journal_B09PP57GQM.7640da61.jpg";